var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 3.79175C3.375 2.68718 4.27043 1.79175 5.375 1.79175H6.625C8.28185 1.79175 9.625 3.13489 9.625 4.79175V5.62508C9.625 7.00579 10.7443 8.12508 12.125 8.12508H12.625C14.2819 8.12508 15.625 9.46823 15.625 11.1251V15.2084C15.625 16.313 14.7296 17.2084 13.625 17.2084H5.375C4.27043 17.2084 3.375 16.313 3.375 15.2084V3.79175Z",
    stroke: "#14142A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 3.79175C3.375 2.68718 4.27043 1.79175 5.375 1.79175H6.43788C8.79769 1.79175 11.0371 2.83361 12.5572 4.63866L13.7443 6.04837C14.9589 7.49074 15.625 9.31579 15.625 11.2015V15.2084C15.625 16.313 14.7296 17.2084 13.625 17.2084H5.375C4.27043 17.2084 3.375 16.313 3.375 15.2084V3.79175Z",
    stroke: "#14142A",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.636be2b58cd6b09e7b9dc3335e161cad.svg";
export { ForwardRef as ReactComponent };